import { SET_REPORTS_SETTINGS, SET_COMPANY_SETTINGS } from '@/store/mutations';

const reports = {
  state: {
    reportsSettings: {
      emailbody: '',
      emailmonitor: '',
      emailsubject: '',
      mailfrom: '',
      mailsendername: '',
      monitorenabled: false,
      reportname: 'timestamp',
    },
    companySettings: {
      company_name: '',
      company_url: '',
      company_logo: '',
      company_desc: '',
    },
  },
  mutations: {
    [SET_REPORTS_SETTINGS]: (state, payload) => (state.reportsSettings = payload),
    [SET_COMPANY_SETTINGS]: (state, payload) => (state.companySettings = payload),
  },
  getters: {
    getReportsSettings: (state) => state.reportsSettings,
    getCompanySettings: (state) => state.companySettings,
  },
  actions: {
    setReportsSettings({ commit, getters }, payload = {}) {
      const reportsSettings = getters.getReportsSettings;
      const newSettings = {
        ...reportsSettings,
      };
      Object.keys(payload).forEach((key) => (newSettings[key] = payload[key]));
      commit(SET_REPORTS_SETTINGS, newSettings);
    },
    setCompanySettings({ commit, getters }, payload = {}) {
      const companySettings = getters.getCompanySettings;
      const newSettings = {
        ...companySettings,
      };
      Object.keys(payload).forEach((key) => (newSettings[key] = payload[key] ?? ''));
      commit(SET_COMPANY_SETTINGS, newSettings);
    },
  },
};

export default reports;
